module.exports = __webpack_public_path__ + "static/img/xxlstar.0292708.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xxlstar.png
// module id = xHRD
// module chunks = 1